<template>
  <a-row :gutter="20" class="dashboard">
    <a-col :span="isDesktop ? 12 : 24">
      <a-card :title="$t('cardTitle.updateBillingInfo')" class="style3 updateBillingInfo">
        <div class="mb-4">
          <div v-if="isFailedPayment" data-show="true" class="ant-alert ant-alert-error ant-alert-no-icon ant-alert-closable" style="margin-bottom: 1rem;">
            <span class="ant-alert-message"
              >Your Payment is Past Due. In order to login please update your credit card information. If you have other questions, please call 1-800-749-0570 or
              <a href="https://truelife.org/pages/contact-truelife-org" target="_blank">click here</a>.</span
            ><span class="ant-alert-description"></span>
          </div>
          <template v-if="billingInfo">
            <a-descriptions :title="null" :column="1">
              <a-descriptions-item label="User Name"> {{ billingInfo.first_name }} {{ billingInfo.last_name }} </a-descriptions-item>
              <a-descriptions-item label="Address"> {{ billingInfo.address1 }}, {{ billingInfo.city }}, {{ billingInfo.state }} {{ billingInfo.zip }} </a-descriptions-item>
              <a-descriptions-item label="Card"> **** **** **** {{ billingInfo.last_four }} </a-descriptions-item>
              <a-descriptions-item label="Expiration"> {{ billingInfo.month }}/{{ billingInfo.year }} </a-descriptions-item>
            </a-descriptions>
          </template>
          <template v-else>
            <p>How would you like to pay?</p>
            <a-radio-group v-model="paymentMethod">
              <a-radio :value="'credit_card'"> Credit Card </a-radio>
            </a-radio-group>
          </template>
        </div>

        <a-button type="primary" class="tf-btn tf-btn-primary" @click="editPayment">
          {{ billingInfo ? 'Update Payment' : 'Add Payment Method' }}
        </a-button>

        <a-modal :title="(billingInfo ? 'Update' : 'Add') + ' Payment'" :visible="showBillingModal" :width="isDesktop ? 800 : 520" centered :footer="null" :closable="false">
          <a-form :form="form" :layout="'vertical'" @submit="handleSubmit" id="billingInfo">
            <a-row>
              <a-col :md="{ span: 10, offset: 1 }">
                <a-form-item :label="$t('label.firstNameFirstHalfChurchName')">
                  <a-input data-recurly="first_name" v-decorator="['first_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputFirstName') }] }]" />
                </a-form-item>
              </a-col>
              <a-col :md="{ span: 10, offset: 1 }">
                <a-form-item :label="$t('label.lastNameSecondHalfChurchName')">
                  <a-input data-recurly="last_name" v-decorator="['last_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputLastName') }] }]" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="{ span: 10, offset: 1 }">
                <a-form-item :label="$t('label.cardNumber')">
                  <a-input
                    @keypress.native="isNumber($event)"
                    data-recurly="number"
                    autocomplete="cc-number"
                    v-decorator="['number', { rules: [{ required: true, message: $t('placeholder.pleaseInputCardNumber') }] }]"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="{ span: 10, offset: 1 }">
                <a-form-item :label="$t('label.expirationDate')" :style="{ display: 'inline-block' }">
                  <a-input-group compact>
                    <a-input
                      data-recurly="month"
                      name="month"
                      autocomplete="cc-exp-month"
                      style="width: 50px; text-align: center;"
                      placeholder="MM"
                      :maxLength="2"
                      v-decorator="['expirationMonth', { rules: [{ required: true }] }]"
                    />
                    <a-input style="width: 30px; border-left: 0; pointer-events: none; backgroundcolor: #fff; text-align: center; padding: 0;" placeholder="/" disabled />
                    <a-input
                      data-recurly="year"
                      name="year"
                      autocomplete="cc-exp-year"
                      style="width: 50px; border-left: 0; text-align: center;"
                      :maxLength="2"
                      placeholder="YY"
                      v-decorator="['expirationYear', { rules: [{ required: true }] }]"
                    />
                  </a-input-group>
                </a-form-item>
                <a-form-item :label="$t('label.CVV')" :style="{ display: 'inline-block', width: '110px', 'margin-left': '20px' }">
                  <a-input
                    @keypress.native="isNumber($event)"
                    data-recurly="cvv"
                    autocomplete="cc-cvv"
                    :maxLength="3"
                    v-decorator="['cvv', { rules: [{ required: true, message: $t('placeholder.pleaseInputCVV') }] }]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="{ span: 10, offset: 1 }">
                <a-form-item :label="'Billing Address'">
                  <a-input data-recurly="address1" v-decorator="['address1', { rules: [{ required: true }] }]" placeholder="Address 1" />
                </a-form-item>
              </a-col>
              <a-col :md="{ span: 10, offset: 1 }">
                <a-form-item :label="' '">
                  <a-input data-recurly="address2" v-decorator="['address2']" placeholder="Address 2" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="{ span: 10, offset: 1 }">
                <a-form-item>
                  <a-input data-recurly="city" v-decorator="['city', { rules: [{ required: true }] }]" placeholder="City" />
                </a-form-item>
              </a-col>
              <a-col :md="{ span: 10, offset: 1 }">
                <a-form-item :style="{ display: 'inline-block', width: '180px' }">
                  <a-input data-recurly="state" v-decorator="['state', { rules: [{ required: true }] }]" placeholder="State" />
                </a-form-item>
                <a-form-item :style="{ display: 'inline-block', width: '110px', 'margin-left': '20px' }">
                  <a-input data-recurly="postal_code" v-decorator="['postal_code', { rules: [{ required: true }] }]" placeholder="Zip Code" />
                </a-form-item>
              </a-col>
            </a-row>

            <input type="hidden" data-recurly="country" value="US" />
            <input type="hidden" data-recurly="token" name="recurly_code" id="recurlyCode" />

            <a-row>
              <a-col :md="{ span: 22, offset: 1 }">
                <p class="text-small">TrueLife.org accepts all major credit and debit cards</p>
                <p><a-icon type="lock" /> Powered by Recurly</p>
              </a-col>
            </a-row>

            <div class="text-right">
              <a-button key="back" @click="e => (showBillingModal = false)"> Cancel </a-button>
              <a-button key="submit" type="primary" class="tf-btn-primary ml-4" html-type="submit" :loading="isLoading"> {{ billingInfo ? 'Update' : 'Add' }} Card </a-button>
            </div>
          </a-form>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { mapState } from 'vuex';
import PaymentService from '@/services/PaymentService';
import initRecurly from '@/services/Recurly';
import { get, isEmpty } from 'lodash';
export default {
  data: () => ({
    isLoading: false,
    showBillingModal: false,
    paymentMethod: 'credit_card',
  }),
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'billingInfo' });
  },
  computed: {
    ...mapState(['settings', 'user']),
    ...mapState({
      billingInfo: state => state.payment.billingInfo,
    }),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    isFailedPayment() {
      if (!this.billingInfo) {
        return true;
      }

      const membership = this.user.user.membership;
      return !membership || membership.state === 'past_due';
    },
  },
  async mounted() {
    await initRecurly();
    await this.doInitData();
  },
  methods: {
    async doInitData() {
      if (isEmpty(this.billingInfo)) {
        await this.$store.dispatch('fetchBillingInfo');
      }
    },
    checkoutRecurly() {
      return new Promise((resolve, reject) => {
        recurly.token(document.getElementById('billingInfo'), err => {
          if (!isEmpty(err)) {
            reject(err);
          } else {
            resolve();
          }
        });
      });
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    editPayment() {
      this.showBillingModal = true;
      if (this.billingInfo) {
        setTimeout(() => {
          // eslint-disable-next-line camelcase
          const { first_name, last_name, address1, address2, city, state, zip } = this.billingInfo;
          this.form.setFieldsValue({
            first_name,
            last_name,
            address1,
            address2,
            city,
            state,
            postal_code: zip,
          });
        });
      }
    },
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (!/^(0[1-9]|1[0-2])\/?([0-9]{2})$/gm.test(`${values.expirationMonth}/${values.expirationYear}`)) {
            this.$notification['error']({
              message: 'Error',
              description: 'The format of Expiration Date is invalid.',
            });

            return;
          }

          try {
            this.isLoading = true;
            try {
              await this.checkoutRecurly();
            } catch (e) {
              this.$notification['error']({
                message: 'Error',
                description: 'There was an error processing your payment information. Please check that all fields are filled in correctly and try again.',
              });

              return;
            }

            const resp = await PaymentService.setBillingInfo(document.getElementById('recurlyCode').value);
            this.$store.dispatch('updateBillingInfo', resp);
            this.form.resetFields();

            this.$notification['success']({
              message: 'Update successful.',
              description: `Credit Card Saved`,
            });
            this.showBillingModal = false;
          } catch (error) {
            console.log(error);
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>
